import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";
var STORAGE_KEY = "isDarkMode";
var DEFAULT_IS_DARK = process.env.NEXT_PUBLIC_USE_LIGHT_THEME !== "true";
function applyTheme(isDark) {
  if (typeof document === "undefined") return;
  document.body.classList.toggle("dark", isDark);
}
if (typeof document !== "undefined") {
  document.documentElement.classList.remove("dark");
}
var legacyStorage = {
  getItem: function getItem(_name) {
    if (typeof window === "undefined") return null;
    var raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return null;
    return {
      state: {
        isDark: raw === "true"
      },
      version: 0
    };
  },
  setItem: function setItem(_name, value) {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(STORAGE_KEY, String(value.state.isDark));
  },
  removeItem: function removeItem(_name) {
    if (typeof window === "undefined") return;
    window.localStorage.removeItem(STORAGE_KEY);
  }
};

/** Global theme store. Use `toggle()` or `setDark()` to change the mode. */
export var useThemeStore = create()(devtools(persist(function (set, get) {
  return {
    isDark: DEFAULT_IS_DARK,
    toggle: function toggle() {
      var next = !get().isDark;
      set({
        isDark: next
      }, false, "toggle");
      applyTheme(next);
    },
    setDark: function setDark(isDark) {
      set({
        isDark: isDark
      }, false, "setDark");
      applyTheme(isDark);
    }
  };
}, {
  name: STORAGE_KEY,
  storage: legacyStorage,
  onRehydrateStorage: function onRehydrateStorage() {
    return function (state) {
      if (state) applyTheme(state.isDark);
    };
  }
}), {
  name: "ThemeStore",
  enabled: typeof window !== "undefined" && process.env.NODE_ENV !== "production"
}));